import { AdminRolesEnum } from 'shared/enums/user-roles-enum'
import { useUserStatus } from 'shared/hooks/use-user/hooks/use-user-status'
import { UserInterface } from 'shared/types/user-interface'

export const isPublicApiSettingsAllowed = ({
  user,
  isWsAdmin,
  isWorkspaceOwner,
}: {
  user: UserInterface | undefined
  isWsAdmin: boolean
  isWorkspaceOwner: boolean
}) => user && (isWorkspaceOwner || isWsAdmin)
